export type ContactKind = 'email' | 'phone' | 'mobile';
export function validEmail(value: unknown, max = 254): boolean {
 const s = String(value ?? '').trim();
 if (!s || s.length > max || !/^[\x21-\x7e]+$/.test(s)) return false;
 const parts=s.split('@'); if(parts.length!==2||parts[0].length>64) return false;
 if(!/^[A-Za-z0-9!#$%&'*+/=?^_{}\x60|~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_{}\x60|~-]+)*$/.test(parts[0]))return false;
 const labels=parts[1].split('.');return labels.length>1&&labels.every(x=>x.length<=63&&/^[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?$/.test(x))&&/[A-Za-z]/.test(labels[labels.length-1]);
}
function grouped(d:string):string {
 if(d.startsWith('02'))return d.length===9?d.slice(0,2)+'-'+d.slice(2,5)+'-'+d.slice(5):d.slice(0,2)+'-'+d.slice(2,6)+'-'+d.slice(6);
 if(d.length===8)return d.slice(0,4)+'-'+d.slice(4);
 if(d.startsWith('050')&&d.length===12)return d.slice(0,4)+'-'+d.slice(4,8)+'-'+d.slice(8);
 return d.slice(0,3)+'-'+d.slice(3,-4)+'-'+d.slice(-4);
}
export function normalizePhone(value: unknown, mobile=false): string | null {
 const s=String(value??'').trim();if(!s)return '';
 if(!mobile&&/^\+[1-9][0-9]*(?:[ -][0-9]+)*$/.test(s)){
  const d=s.replace(/[ -]/g,'');return /^\+[1-9][0-9]{7,14}$/.test(d)?d:null;
 }
 if(!/^[0-9]+(?:-[0-9]+){0,2}$/.test(s))return null;
 const d=s.replace(/-/g,'');
 const ok=mobile?/^010[0-9]{8}$/.test(d):/^(?:010[0-9]{8}|01[16789][0-9]{7,8}|02[0-9]{7,8}|0(?:3[1-3]|4[1-4]|5[1-5]|6[1-4])[0-9]{7,8}|070[0-9]{8}|080[0-9]{7,8}|050[0-9]{8,9}|1[568][0-9]{6})$/.test(d);
 if(!ok)return null;const formatted=grouped(d);return s===d||s===formatted?formatted:null;
}
export function formatPhoneDraft(value: unknown,mobile=false):string {
 const s=String(value??'');if(!/^[0-9-]*$/.test(s)||s.includes('--'))return s;
 const d=s.replace(/-/g,'');if(d.length>12)return s;
 if(s.includes('-')){
  const p=s.split('-');const head=d.startsWith('02')?2:d.startsWith('050')&&p[0].length===4?4:3;
  if(p.length>3||p[0].length!==head||p.slice(1).some(x=>x.length>4))return s;
 }
 const valid=normalizePhone(s,mobile);if(valid)return valid;
 if(!d)return s;
 const head=d.startsWith('02')?2:d.startsWith('050')&&d.length===12?4:/^1[568]/.test(d)?4:3;
 if(d.length<=head)return d;
 if(d.length<=head+4)return d.slice(0,head)+'-'+d.slice(head);
 return d.slice(0,head)+'-'+d.slice(head,head+4)+'-'+d.slice(head+4);
}
